import React, { useEffect, useState } from 'react'
import { AppConfigurator } from './fields/AppConfigurator'
import {
  SimpleBridgeBuilderCard,
  SimpleBridgeBuilderCardSeparator,
  SimpleBridgeBuilderWrapper,
  IntegrationRequestLink,
} from './styled'
import { HiArrowRight } from 'react-icons/hi'
import { useHandleAppsCompatibility } from '@features/nbee/SimpleBridgeBuilderForm/appsCompatibility/useHandleAppsCompatibility'
import { useFormikContext } from 'formik'
import { BridgeFormValues, AppIntegrationSetting } from 'Nbee'
import { EmailReceipt } from '@features/nbee/EmailReceipt'
import { ApiUserModuleItem, ApiUser } from 'BackendApi'
import { ModalIntegrationRequest } from '@features/nbee/ModalIntegrationRequest'
import { useTranslation } from 'react-i18next'

interface FormInnerProps {
  emailReceiptUserModule?: ApiUserModuleItem
  userData?: ApiUser
  templateSettings?: AppIntegrationSetting[]
}

export const FormInner: React.FC<FormInnerProps> = ({
  emailReceiptUserModule,
  userData,
  templateSettings,
}) => {
  const { t } = useTranslation()
  const { appsAreCompatible, emailFeatureAvailable } =
    useHandleAppsCompatibility()
  const { values, setFieldValue } = useFormikContext<BridgeFormValues>()

  const bridgeId = values?.ui?.bridgeId
  const [isModalOpen, setIsModalOpen] = useState(false)

  const isEditMode = Boolean(bridgeId)
  const hasBothAppsSelected = Boolean(
    values.source.appId && values.destination.appId
  )
  const showRequestLink = !isEditMode && !hasBothAppsSelected

  useEffect(() => {
    if (emailFeatureAvailable !== undefined) {
      // update formik context with email feature availability
      setFieldValue('settings.emailReceipt.canShow', emailFeatureAvailable)
    }
  }, [emailFeatureAvailable])

  return (
    <>
      <SimpleBridgeBuilderWrapper>
        {/* SOURCE */}
        <SimpleBridgeBuilderCard
          hasError={values.ui?.source?.hasSettingsApiError}
        >
          <AppConfigurator
            type='source'
            canShowIntegrationField={appsAreCompatible}
            templateSettings={templateSettings}
          />
        </SimpleBridgeBuilderCard>
        {/* SEPARATOR */}
        <SimpleBridgeBuilderCardSeparator>
          <HiArrowRight size={'1.5rem'} />
        </SimpleBridgeBuilderCardSeparator>
        {/* DESTINATION */}
        <SimpleBridgeBuilderCard
          hasError={values.ui?.destination?.hasSettingsApiError}
        >
          <AppConfigurator
            type='destination'
            canShowIntegrationField={appsAreCompatible}
          />
          <EmailReceipt
            bridgeId={bridgeId}
            emailReceiptUserModule={emailReceiptUserModule}
            userData={userData}
          />
        </SimpleBridgeBuilderCard>
      </SimpleBridgeBuilderWrapper>

      {showRequestLink && (
        <IntegrationRequestLink onClick={() => setIsModalOpen(true)}>
          {t('nbee.integrationRequest.linkText')}
        </IntegrationRequestLink>
      )}

      <ModalIntegrationRequest
        isOpen={isModalOpen}
        onCloseModal={() => setIsModalOpen(false)}
      />
    </>
  )
}
